import { isAnyOf } from '@reduxjs/toolkit'

import {
  readActiveOrgPreference,
  writeActiveOrgPreference,
} from '@/features/auth/lib/activeOrgPreference'
import { startAppListening } from '@/store/listenerMiddleware'

import {
  activeOrgSelected,
  fetchMe,
  probeSession,
  refreshMe,
  signIn,
} from './sessionSlice'

/**
 * Active-org persistence (TASK-7F3EE34E). Kept out of the reducers (they stay
 * pure): a choice is written when it is made, and a freshly loaded session
 * re-selects the remembered org. `activeOrgSelected` ignores an org the caller
 * is not a member of, so a stale or foreign preference changes nothing.
 *
 * Registers on import, like `store/cacheFollowUps.ts`.
 */
startAppListening({
  actionCreator: activeOrgSelected,
  effect: (action, { getState }) => {
    // Remember only what the reducer accepted (a non-member org is ignored there).
    if (getState().session.activeOrgId === action.payload)
      writeActiveOrgPreference(action.payload)
  },
})

startAppListening({
  matcher: isAnyOf(
    signIn.fulfilled,
    fetchMe.fulfilled,
    refreshMe.fulfilled,
    probeSession.fulfilled
  ),
  effect: (_action, { dispatch, getState }) => {
    const preferred = readActiveOrgPreference()
    if (preferred !== null && preferred !== getState().session.activeOrgId) {
      dispatch(activeOrgSelected(preferred))
    }
  },
})
